// Generated by Melange

import * as Store__Albums from "./albums.jsx";
import * as Store__Artists from "./artists.jsx";
import * as Store__Auth from "./auth.jsx";
import * as Store__Player from "./player.jsx";
import * as Store__Songs from "./songs.jsx";
import * as Zustand from "zustand";

function make(param) {
  return Zustand.createStore(function (set, param, param$1) {
    return {
      albums: Store__Albums.make(undefined),
      artists: Store__Artists.make(undefined),
      auth: Store__Auth.make(set),
      player: Store__Player.make(undefined),
      songs: Store__Songs.make(undefined)
    };
  });
}

export {
  make,
}
/* Store__Auth Not a pure module */
